import SquadBoldText from './SquadBoldText';

export default SquadBoldText;
